import { Component } from '@angular/core';

@Component({
  selector: 'app-locations',
  template: `
                <div>
                    <router-outlet></router-outlet>
                </div>
             ` ,
})

export class LocationsComponent {

}
